const getters = {
  getB2bUserCartTotal: (state) => ({ market, id }) => {
    const { contactItems } = state.b2bCarts.marketCarts[market.toLowerCase()];
    return contactItems[id]?.total ?? 1;
  },
  getB2bUserCartWeight: (state) => ({ market, id }) => {
    const { contactItems } = state.b2bCarts.marketCarts[market.toLowerCase()];
    return contactItems[id]?.cartWeight ?? 0;
  },
  getB2bUserShippingTotal: (state) => ({ market, id }) => {
    const { contactItems } = state.b2bCarts.marketCarts[market.toLowerCase()];
    const shippingCost = contactItems[id]?.shipping;
    if (!shippingCost) {
      return null;
    }
    return shippingCost;
  },
  b2bRole: (state) => {
    if (state.b2b?.role) {
      return state.b2b?.role ?? null;
    }
    return false;
  },
  b2bId: (state) => state.b2b?.companyId ?? '',
  b2bUserList: (state) => state.user?.b2bUserList ?? [],
  b2bCartLocations: (state) => state.b2bCarts?.markets ?? [],
  b2bCarts: (state) =>
    state.b2bCarts && state.b2bCarts.marketCarts
      ? state.b2bCarts.marketCarts
      : [],
  b2bCompany: (state) => ({
    companyId: state.b2b?.companyId ?? '',
    companyName: state.b2b?.companyName ?? '',
    contactId: state.b2b?.id ?? '',
    locationId: state.b2b?.locationId ?? ''
  }),
  b2bMarketCartTotals: (state) => {
    const cartTotals = {};
    if (state.b2bCarts && state.b2bCarts.marketCarts) {
      Object.keys(state.b2bCarts.marketCarts).forEach((market) => {
        if (state.b2bCarts.marketCarts[market]) {
          cartTotals[market] = {
            productQuantity:
              state.b2bCarts.marketCarts[market].productQuantity || 0,
            recipientsQuantity:
              state.b2bCarts.marketCarts[market].recipientsQuantity || 0,
            shipping: state.b2bCarts.marketCarts[market].shipping || 0,
            total: state.b2bCarts.marketCarts[market].total || 0
          };
        }
      });
    }
    return cartTotals;
  },
  b2bGroupsList: (state) => JSON.parse(state.b2b.groups).groups,
  b2bOrders: (state) => state.user.b2b?.orders ?? [],
  b2bOrder: (state) => (id = null) => {
    const prefix = 'gid://shopify/Order/';
    if (id && !id.startsWith(prefix)) {
      id = prefix + id;
    }
    const order = state.user.b2b.orders.find((theOrder) => theOrder.id === id);
    if (order) {
      return order;
    }
    return {};
  },
  b2bOrdersPagination: (state) => state.user.b2b?.orderPagination ?? null,
  b2bOrdersTotal: (state) => state.user.b2b?.totalOrders ?? 0,
  getDiscountCode: (state) => state.b2bCarts.global.discountCodes[0] ?? '',
  getAttachUserOpenInCart: (state) =>
    state.b2bCarts.global.attachUserOpenInCart ?? false,
  b2bApiCartHash: (state) => state.b2bApiCartHash ?? '',
  b2bGlobalProducts: (state) => state.b2bCarts.global.products ?? {},
  recipients: (state) => state.user.b2bUserList,
  allRecipients: (state) => state.cart.marketCarts?.allRecipients ?? [],
  getGlobalGiftMessage: (state) => state.b2bCarts.global.giftMessage ?? '',
  getProductAndRecipintsByMarket: (state) => (market = 'ie') => {
    market = market.toUpperCase();
    const products = [];
    const marketCart = Object.values(state.b2bCarts.global.products);
    marketCart.forEach((product) => {
      Object.values(product.recipients || []).forEach((recipient) => {
        if (recipient.market === market) {
          products[recipient.id] = recipient.lineitem.merchandise.product.id;
        }
      });
    });
    return products;
  }
};
export default getters;
